/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ConnectLarkUpdate = lazyLoad(
  () => import('./index'),
  module => module.ConnectLarkUpdate
);
